import React, { memo, useEffect, useRef, useState } from 'react'

import MultiSelect from '@khanacademy/react-multi-select'

import { classnames, Icon, UnfoldLess, UnfoldMore } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function SoftwareField({ options, selected, onChange, errorText }) {
  const t = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const controlRef = useRef(null)

  // MultiSelect exposes no open/close prop, but its root reflects the state as `aria-expanded`.
  // Observe that attribute so the caret icon (UnfoldMore/UnfoldLess) stays in sync however the
  // dropdown is toggled (header click, outside click, Escape).
  useEffect(() => {
    const dropdown = controlRef.current?.querySelector('[aria-expanded]')

    if (!dropdown) return undefined

    const syncOpenState = () => setIsOpen(dropdown.getAttribute('aria-expanded') === 'true')

    syncOpenState()

    const observer = new MutationObserver(syncOpenState)

    observer.observe(dropdown, { attributes: true, attributeFilter: ['aria-expanded'] })

    return () => observer.disconnect()
  }, [])

  return (
    <div className="software-field">
      <span className="software-field__label cgt-body-base-semibold">
        {t('viewerSidebar.enhance.assist.software.label')}
        <b className="cgt-legacy-color-utility-danger-100"> *</b>
      </span>

      <div
        className={classnames('software-field__control', !!errorText && 'software-field__control--error')}
        ref={controlRef}
      >
        <MultiSelect
          options={options}
          selected={selected}
          onSelectedChanged={onChange}
          placeholder={t('viewerSidebar.enhance.assist.software.placeholder')}
          hasSelectAll={false}
        />
        <Icon
          svgComponent={isOpen ? UnfoldLess : UnfoldMore}
          color="darker"
          className="software-field__caret"
          aria-hidden
          size="small"
        />
      </div>

      {!!errorText && (
        <span className="software-field__error cgt-body-base-semibold cgt-legacy-color-utility-danger-100">
          {errorText}
        </span>
      )}
    </div>
  )
}

SoftwareField.propTypes = {
  options: arrayOf(shape({
    value: oneOfType([number, string]),
    label: string,
  })).isRequired,
  selected: arrayOf(oneOfType([number, string])).isRequired,
  onChange: func.isRequired,
  errorText: string.isRequired,
}

export default memo(SoftwareField)
